import { common } from '../../main/common-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew_movable } from './voyageCrew_movable-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

export interface IVoyageCrewAnimal {
  // fireExtinguishTimer: number
  // useSystemTimer: number
  moveTimer: number
}

export function create() {
  let d: IVoyageCrewAnimal = {
    // fireExtinguishTimer: 0,
    // useSystemTimer: 0,
    moveTimer: 0,
  }
  return d
}

export function update(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  // let d = obj.alienState
  // assert.notNil(d)

  if (obj.isDead) {
    return
  }
  if (obj.isDying) {
    return
  }

  if (obj.path) {
    return
  }

  obj.moveTimer += ds
  if (obj.moveTimer > 2) {
    obj.moveTimer = 0

    if (voyageWebsockets.getIsHost()) {
      let rf = voyageTilemap.getRandomFloor()

      voyageCrew_movable.pathTo(obj, rf.i, rf.j)
    }
  }

  //  voyageGameStatus.get().hasBoarders.willBeActive = true
}
